export const PAYMENT_TYPE = {
  PER_HOUR: 1,
  PER_DAY: 2,
  PER_OCCURANCE: 3,
};

export const PAYMENT_TYPE_OPTIONS = [
  { value: PAYMENT_TYPE.PER_HOUR, label: "Stawka godzinowa" },
  { value: PAYMENT_TYPE.PER_DAY, label: "Stawka etatowa" },
  { value: PAYMENT_TYPE.PER_OCCURANCE, label: "Za wystąpienie" },
];
